module.exports = "<p>\n  telecaller works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller/telecaller.component.html
// module id = ./src/app/prospect/telecaller/telecaller.component.html
// module chunks = main